import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import {COMMIT_ALL_KEY, formatNumber} from "./blockConfig"

class TableTemplate extends Component {
    render() {
        const {data, loading, error, commitBlock} = this.props

        return (
            <div className="StaticsTableCreated">
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th className='text-left'>SKU</th>
                        <th>Số lượng</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        loading === null && !!error && error.length > 0 && <tr>
                            <td colSpan={2} className='text-danger'>{error}</td>
                        </tr>
                    }

                    {
                        loading && <tr>
                            <td colSpan={2}>Loading...</td>
                        </tr>
                    }

                    {
                        !!data && data.length > 0 && data.map((item, index) =>
                            <tr
                                key={index}
                                title={item.dateFullyDone ? `${formatNumber(item.total)} item quá hạn phân lô` : undefined}
                                style={item.dateFullyDone ? {background:'rgba(223, 31, 31, 0.1)'} : {}}
                            >
                                <td className='SKU text-left' title={item.type} style={item.dateFullyDone ? {color:'#DF1F1F'} : {}}>{item.type}</td>
                                <td className='Quantity'>
                                    <Link
                                        to={{
                                            pathname: "/",
                                            search: commitBlock === COMMIT_ALL_KEY
                                                ? `?type=${item.type}&status=fully-done`
                                                : `?type=${item.type}&status=fully-done&commitBlock=${commitBlock}`
                                        }}
                                        target='_blank'
                                        style={item.dateFullyDone ? {color:'#DF1F1F'} : {}}
                                    >
                                        {formatNumber(item.total)}
                                    </Link>
                                </td>
                            </tr>
                        )
                    }

                    {
                        error.length === 0 && !loading && data.length === 0 && <tr>
                            <td colSpan={2}>Không có SKU nào khớp bộ lọc.</td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

TableTemplate.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string,
    commitBlock: PropTypes.string
}

export default TableTemplate
